import { Page, Container, ContentHeader } from 'components'
import { FormUsers } from 'components/Users'

const UsersNew = () => {
  return (
    <Page title="Novo usuário">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          title="Criação"
          menu="Usuários"
          subtitle="Criação de usuário"
        ></ContentHeader>
        <FormUsers userClient />
      </Container>
    </Page>
  )
}
export default UsersNew
